





















































































































































































































































































































































































































































































import {Vue, Component} from 'vue-property-decorator';
import BExecAgrHistModal from '@/modules/budget/monitoring/input-forms/components/BExecAgrHistModal.vue'
import BEIFOpenWindow from "@/modules/budget/monitoring/input-forms/BEIFOpenWindow.vue";
import CBudgetAgreementModal from "@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue";
import VueElementLoading from "vue-element-loading";
import axios from "axios";
import { Ax } from '@/utils'
import store from "@/services/store";
import { FilterSettingsForm } from '@/modules/budget/monitoring/input-forms/types/roots/FilterSettingsForm'
import { Facade } from '@/modules/budget/monitoring/input-forms/types/roots/Facade'
import { InputFormFacade } from "@/modules/budget/monitoring/input-forms/types/inputFormFacade";
import { isParentLocked, parentErrorText } from '@/modules/budget/monitoring/input-forms/common/parentError'

const d3Forms = ['app19', 'app13cons', 'app13_ob', 'app17', 'app13_rn', 'app15']

/** Module translation path */
const trPath = 'modules.budget_execution_monitoring.input_forms'

@Component({
    components: {
        'b-exec-agr-hist-modal': BExecAgrHistModal,
        'beif-open-window': BEIFOpenWindow,
        'c-budg-agr-modal': CBudgetAgreementModal,
        'loading': VueElementLoading
    },
    filters: {
        formatDate(value: any) {
            if (value) {
                const date = new Date(value*1000);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
})
export default class InputForms extends Vue {
    // $refs!: {
    //     refHistModal: HTMLFormElement,
    //     app_window: HTMLFormElement
    // }
    private tableFields:any[] = [
        {
            label: '',
            key: 'action'
        },
        {
            label: '№',
            key: 'number'
        },
        {
            label: 'Регион',
            key: 'region'
        },
        {
            label: 'АБП',
            key: 'abp'
        },
        {
            label: 'БП',
            key: 'prg'
        },
        {
            label: 'Приказ',
            key: 'order_number'
        },
        // {
        //     label: 'Тип',
        //     key: 'type'
        // },
        {
            label: 'Форма',
            key: 'form'
        },
        {
            label: 'Отчётный период',
            key: 'rep_period'
        },
        {
            label: 'Статус',
            key: 'status'
        },
        {
            label: 'Дата обновления',
            key: 'update_date'
        },
        {
            label: 'Пользователь',
            key: 'user'
        },
        {
            label: '',
            key: 'description'
        },
        {
            label: '',
            key: 'more'
        }
    ]
    // отдельная колонка-заголовок для шеврона свёртывания/развёртывания групп app21 (RQ.25);
    // в строках таблицы своего <td> не имеет - остаётся пустой ячейкой для выравнивания колонок
    private get visibleTableFields(): any[] {
        if (!this.form || this.form.code !== 'app21') {
            return this.tableFields
        }
        const fields = [...this.tableFields]
        fields.splice(1, 0, { label: '', key: 'expand' })
        return fields
    }
    private user_id:string|null = null
    private userBudgetLevel: string[] = []
    private moduleAccess:any = null;
    private statusList:any[] = []
    private realmUsers:any[] = []
    private currYear:number = new Date().getFullYear();
    private months:any[] = [];
    private selectedMonth:any = null;
    private selectedStatus:any = null;
    private childStatus:any = null;
    private obl:string|null = null;
    private region:any = null
    private regionBase:any[] = []
    private regionDict:any = {}
    private currAbp:any = null
    public readonly d3Forms = d3Forms
    private abpBase:any[] = []
    private currPrg:any = null
    private prgBase:any[] = []
    private prgCacheByAbp: Record<string, any[]> = {}
    private prgCacheLoading: Record<string, boolean> = {}
    private get regionList() {
        return this.regionBase
    }
    private get abpList() {
        const list = []
        let inputList:any[] = [...this.abpBase]
        if (this.abpBase.length > 1) {
            inputList = [{
                abp: null,
                name_ru: 'Все',
                name_kk: 'Барлығы'
            }, ...this.abpBase]
        }
        for (const abp of inputList) {
            const abpObj = Object.assign({}, abp)
            abpObj.name = abpObj.abp !== null? `${abpObj.abp} - ${abpObj[`name_${this.$i18n.locale}`]}`: abpObj[`name_${this.$i18n.locale}`]
            list.push(abpObj)
        }
        list.sort((a, b) => a.abp - b.abp)
        return list
    }
    private get filterYears() {
        const now = new Date();
        let yearNow = now.getFullYear();

        if (now.getMonth() == 11) { // Для возможности заранее заполнить приложение 19
            yearNow++
        }

        const years = [];
        for (let i = yearNow; i >= yearNow - 10; i--) {
            if (i >= 2020) {
                years.push(i);
            }
        }
        return years;
    }
    private get repdate() {
        const month = this.selectedMonth.key
        const year = this.currYear
        // if (month === 0) {
        //     month = 11
        //     year = year - 1
        // } else {
        //     month -= 1
        // }
        return new Date(year, month, 0)
    }
    private get repdateText() {
        return `${this.repdate.getFullYear()}-${this.repdate.getMonth() + 1}-${this.repdate.getDate()}`
    }

    public get isCreateButtonVisible() {
        if (this.isApp10) {
            return false
        }

        if (d3Forms.filter(code => code !== 'app19').includes(this.form?.code)) {
            return false
        }
        if (this.form?.code === 'app23') {
            return Boolean(this.currAbp?.abp)
        }

        return this.form
            && this.form.hasOwnProperty('code')
            && this.form.code
            && ( 
                !this.parentCodes.includes(this.form?.code)
                || this.form?.code === 'app19' // Исключение для Приложение 19
                ||  (this.form?.code === 'app41' && Boolean(this.currAbp?.abp)) // Исключение для Приложение 41
            )
    }


    public get isDeleteButtonVisible() {
        const undeletableForms = d3Forms.filter(code => code !== 'app19')
        return !undeletableForms.includes(this.form?.code)
    }

    private repPeriod(form_code:string) {
        const periods = [[1, 2, 3], [1], [1], [1, 2], [1], [1], [1, 2], [1], [1], [1, 2], [1], [1]]

        const period = Math.max(...periods[this.selectedMonth.key])
        if (period === 1 || ['app8_ex', 'app9_ex'].includes(form_code)) {
            return {text: 'Месяц', code: 1}
        } else if (period === 2) {
            return {text: 'Квартал', code: 4}
        } else if (period === 3) {
            return {text: 'Годовой', code: 12}
        }
        return {text: 'День', code: 0}
    }
    private getPeriodText(data:any) {
        if (['app12', 'app12cons', 'app14_rb', 'app14cons_rb', 'app14_ob', 'app14cons_ob', 'app18'].includes(data.form_code)) {
            let month = this.selectedMonth.key - 1
            if (month < 0) {
                month = 11
            }
            return this.months[month].label
        }
        const periodCode = this.repPeriod(data.form_code)
        if (periodCode.code === 1) {
            return this.months[['app8_ex', 'app9_ex'].includes(data.form_code)? ((this.selectedMonth.key + 1) % 12): this.repdate.getMonth()].label
        } else if (periodCode.code === 4) {
            let q = 'I'
            if (this.selectedMonth.key === 6) {
                q += 'I'
            }
            if (this.selectedMonth.key === 9) {
                q += 'II'
            }
            return `${q}  ${this.$t('modules.budget_execution_monitoring.input_forms.period_4').toString().toLowerCase()}`
        } else if (periodCode.code === 12) {
            return `${this.currYear + (['app8_ex', 'app9_ex'].includes(data.form_code)? 1: -1)} ${this.$t('modules.budget_execution_monitoring.input_forms.period_12').toString().toLowerCase()}`
        } else {
            return this.repdateText
        }

    }
    private get isZeroReg() {
        return this.region && this.region.hasOwnProperty('code') && (this.region.code.slice(4, 6) === '00')
    }
    private get isReg() {
        if (this.isZeroReg) {
            return this.region.code.slice(2, 4) !== '00'
        } else {
            return true
        }
    }
    private get haveEditAccess() {
        return this.moduleAccess.access_level > 1
    }
    private get haveDeleteAccess() {
        return this.haveEditAccess
    }
    private repType:number = 2
    private reportFormView = 1
    private currForm:any = null;
    private selectAll:boolean = false;
    private selectAllFroms() {
        this.selectedFormList.splice(0)
        if (this.selectAll) {
            for (const f of this.filteredDataList) {
                this.selectedFormList.push(f)
            }
        }
        // if (this.selectedFormList.length > 0) {this.agreementEvent(false)} else {this.agrEnabled = false}
    }
    private selectedFormList:any[] = []
    private inputFormList:any[] = []
    private orderList:number[] = []
    private selectedOrder: number = 0
    private form:any = null
    private filterSettingsForm: FilterSettingsForm | null = null
    private facade: Facade | null = null
    private inputFormFacade: InputFormFacade | null = null

    private async created() {
        const that = this;
        this.inputFormFacade = new InputFormFacade()
        this.user_id = this.$store.state.user.sub
        const m:any = {
            en: ['January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'],
            kk: ['Қаңтар', 'Ақпан', 'Наурыз', 'Сәуір', 'Мамыр', 'Маусым',
                'Шілде', 'Тамыз', 'Қыркүйек', 'Қазан', 'Қараша', 'Желтоқсан'],
            ru: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь',
                'Октябрь', 'Ноябрь', 'Декабрь']
        }

        for (let i = 0; i < 12; i++) {
            const mo:any = {
                key: i
            }
            Object.defineProperty(mo, 'label', {
                get: function () {
                    return m[that.$i18n.locale][i]
                }
            })
            this.months.push(mo)
        }
        await this.loadOperations()
        await this.loadOrderList()
        this.userBudgetLevel = this.$store.getters.userBudgetLevel.map((v:string) => v.replace('level_', ''))
        this.moduleAccess = this.$store.state.user.userModules.find((v:any) => v.modules === this.moduleCode)
        if (!this.moduleAccess) {
            this.moduleAccess = {
                modules: this.moduleCode,
                access_level: 1
            }
        }
        this.selectedMonth = this.months[new Date().getMonth()];
        await this.loadRegion()
        await this.loadFormsDict()
        await this.loadAbpList()
        await this.loadFormList()
        await this.getAllAgreemenSteps()
        this.statusList = await this.getStatusList(this.mode)
        await this.loadExecutors()


        // TODO на время разработки
        // this.selectedMonth = this.months[9];
        // this.region = this.regionList.find((v:any) => v.code === '450301')
        // await this.regionSelected()
        // this.form = this.inputFormList.find((v:any) => v.code === 'app8_ex')
        // await this.loadData()
        // console.log(this.dataList)
        // this.toggleOpen(this.dataList[0])
    }
    private async chgYear() {
        await this.loadRegion()
        await this.regionSelected()
    }

    public async onMonthSelect(value: any) {
        await this.loadFormList()
    }

    private async regionSelected() {
        await this.loadAbpList()
        await this.loadFormList()
        this.statusList = await this.getStatusList(this.mode)
    }
    private async orderSelected() {
        await this.regionSelected()
    }

    private async loadOrderList() {
        await axios.get('/api-py/input-forms/order-list').then((resp) => {
            this.orderList = resp.data
            this.orderList.unshift(0)
        }).catch((error) => {})
    }

    private async loadFormList() {
        let inputFormList: any[] = []

        const req: any = {
            user_id: this.user_id,
            userBudgetLevel: this.userBudgetLevel,
            region: this.region.code,
            year: this.currYear,
            month: this.selectedMonth.key,
            type: this.repType,
            operations: this.operationCode,
            order_number: this.selectedOrder
        }

        const formsResponse = await axios.post(`/api-py/input-forms/forms`, req)
        if (formsResponse.status === 200) {
            inputFormList = formsResponse.data
        }

        // Приложение 19
        inputFormList = inputFormList.filter(it => !d3Forms.includes(it.code))
        const request19: any = {
            user_budget_level: this.userBudgetLevel,
            region: this.region.code,
            year: this.currYear,
            month: this.selectedMonth.key,
            operations: this.operationCode,
        }

        // app21 — только для регионов, код которых не оканчивается на «00»;
        // уровни справочника {2,3,4} (RQ.60) пропускают районы XXYY00, поэтому отсеиваем здесь
        if (this.region.code.endsWith('00')) {
            inputFormList = inputFormList.filter(it => it.code !== 'app21')
        }
        const forms19Response = await axios.post('/api-py/input-forms/forms/19', request19)
        if (forms19Response.status === 200) {
            forms19Response.data.forEach((form: any) => {
                const index = inputFormList.findIndex(it => it.code === form.code)
                if (index === -1) {
                    inputFormList.push(form)
                } else {
                    inputFormList[index] = form
                }
            })
        }

        // Приложение 23
        inputFormList = inputFormList.filter(it => it.code !== 'app23')
        if (
            this.region?.code && !this.region.code.endsWith('00')
            && this.currYear
            && this.selectedMonth?.key === 0
        ) {
            const request23: any = {
                year: this.currYear,
                user_budget_level: this.userBudgetLevel,
                operations: this.operationCode,
            }
            const form23Response = await axios.post('/api-py/input-forms/forms/23', request23)
            if (form23Response.status === 200) {
                form23Response.data.forEach((form: any) => {
                    const index = inputFormList.findIndex(it => it.code === form.code)
                    if (index === -1) {
                        inputFormList.push(form)
                    } else {
                        inputFormList[index] = form
                    }
                })
            }
        }

        inputFormList.sort((a:any, b:any) => {
            // const aIsEx = a.code.endsWith("_ex");
            // const bIsEx = b.code.endsWith("_ex");
            // if (aIsEx !== bIsEx) {
            //     return aIsEx ? 1 : -1;
            // }
            // return a.code.localeCompare(b.code);
            // return b[`name_${this.$i18n.locale}`].localeCompare(a[`name_${this.$i18n.locale}`], this.$i18n.locale)
            const arrA: string[] = a[`name_${this.$i18n.locale}`]?.split(' ') ?? []
            const arrB: string[] = b[`name_${this.$i18n.locale}`]?.split(' ') ?? []
            let numA: number = 0
            let numB: number = 0
            for (const sa of arrA) {
                const n = parseInt(sa)
                if (n) {
                    numA = n
                    break
                }
            }
            for (const sb of arrB) {
                const n = parseInt(sb)
                if (n) {
                    numB = n
                    break
                }
            }
            return numA - numB
        })
        this.inputFormList = inputFormList
        if (this.inputFormList.length) {
            this.form = this.inputFormList[0]
        } else {
            this.form = null
            this.makeToast('danger', this.$t('modules.common.attention'), this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.error_no_forms_by_parametr'))
        }

        await this.checkFormExist()
    }
    private showViewModelselect:boolean = false;

    private async loadRegion() {
        if (!this.obl) {
            try {
                await fetch('/api-py/get-budget-obl/' + this.$store.state._instanceCode)
                    .then(response => response.json())
                    .then(json => {
                        this.obl = json.obl;
                    });
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса getObl', error.toString());
            }
        }
        const that = this
        await axios.get(`/api-py/input-forms/regions/${this.obl}/${this.user_id}/${this.repdateText}`).then(resp => {
            if (resp.status === 200) {
                const base: any[] = resp.data
                for (const r of base) {
                    that.setNameLang(r, 'code')
                }
                that.regionBase = base
                that.region = that.regionList[0]
                for (const r of that.regionList) {
                    that.regionDict[r.code] = r
                }
             }
        })
    }
    private async loadAbpList() {
        await axios.get(`/api-py/get-abp-by-user-id-region-input-forms/${this.user_id}/${this.region.code}/${this.currYear}/${this.selectedMonth.key}`).then(resp => {
            if (resp.status === 200) {
                this.abpBase = resp.data
                this.currAbp = this.abpList[0]
            }
        })
        if (this.showPrgFilter) {
            await this.loadPrgList()
        }
        await this.checkFormExist()
    }

    private get showAbpFilter() {
        if (['app13_ob', 'app13_rn', 'app15', 'app23'].includes(this.form?.code)) {
            return true
        }

        if (['app41'].includes(this.form?.code)) {
            return true
        }
        return ['app8', 'app8_ex', 'app12', 'app14_rb', 'app14_ob', 'app26', 'app21'].includes(this.form?.code) && (!this.isZeroReg)
    }

    // app21: БП в фильтре необязательна
    private get isApp21(): boolean {
        return this.form?.code === 'app21'
    }

    private get showPrgFilter() {
        return ['app26', 'app21'].includes(this.form?.code) && !this.isZeroReg
    }

    private get prgList() {
        const that = this
        return this.prgBase.map((p: any) => {
            const prgObj = Object.assign({}, p)
            Object.defineProperty(prgObj, 'name', {
                get() {
                    return `${prgObj.prg} - ${prgObj[`name_${that.$i18n.locale}`]}`
                }
            })
            return prgObj
        })
    }

    private async loadPrgList() {
        if (!this.currAbp?.abp) {
            this.prgBase = []
            this.currPrg = null
            return
        }
        const url = this.form?.code === 'app26'
            ? '/api-py/input-forms/reserve-programs'
            : '/api-py/input-forms/budget-programs'
        await axios.post(url, {
            year: this.currYear,
            abp: this.currAbp.abp
        }).then(resp => {
            if (resp.status === 200) {
                this.prgBase = resp.data
                this.currPrg = (this.prgList.length && this.form.code !== 'app21') ? this.prgList[0] : null
            }
        })
    }

    private async onAbpChange() {
        if (this.showPrgFilter) {
            await this.loadPrgList()
        }
        await this.checkFormExist()
    }

    private async loadExecutors() {
        await axios.get('/api-py/get-realm-users/',
            {headers: {
                    Authorization: `Bearer ${this.$store.getters.token}`,
                }})
            .then(resp => {
                if (resp.status === 200) {
                    this.realmUsers = resp.data
                }
            }).catch((error:any) => {})
    }
    private getLocalUser(user_id: any) {
        const infoAboutUser = this.realmUsers.find((d:any) => d.id === user_id)
        if (!infoAboutUser) {
            return ''
        }
        let name = ''
        if (infoAboutUser['lastName']) {
            name += infoAboutUser['lastName']
        }
        if (infoAboutUser['firstName']) {
            name += ' ' + infoAboutUser['firstName']
        }
        return name
    }
    private getDescriptionText(data:any) {
        let text = ''
        if (['app9_ex', 'app8_ex'].includes(data.form_code)) {
            text = ['mb', 'rb', 'ob'].filter(v => data.description[v].trim().length).map(v => `<b>${this.$t(`modules.budget_execution_monitoring.input_forms.forms_table.description.${v}`)}</b>: ${data.description[v]}`).join('\n')
        } else {
            text = data.description.general
        }
        return text
    }
    private async loadFormsDict() {
        const req:any = {
            user_id: this.user_id,
            userBudgetLevel: this.userBudgetLevel,
            region: this.region.code,
            year: this.currYear,
            month: this.selectedMonth.key,
            type: this.repType,
            operations: this.operationCode,
            get_all: true
        }
        await axios.post('/api-py/input-forms/forms', req, {withCredentials: true}).then(resp => {
            if (resp.status === 200) {
                const data: any[] = resp.data
                for (const r of data) {
                    this.appParentCodes[r.code] = r.parent_code
                    this.parentCodes.push(r.parent_code)
                    if (!this.appChildCodes[r.parent_code]) {
                        this.appChildCodes[r.parent_code] = [r.code]
                    } else {
                        this.appChildCodes[r.parent_code].push(r.code)
                    }
                }
                for (const r of data) {
                    if (!this.parentCodes.includes(r.code)) {
                        this.childCodes.push(r.code)
                    }
                }
            }
        })
    }
    private async getStatusList(mode: string) {
        try {
            const that = this;
            let statusList: any[] = [];
            const response = await axios.get(`/api-py/get-status-list/${mode}`);
            if (response.status === 200) {
                statusList = response.data;
                for (const st of statusList) {
                    Object.defineProperty(st, 'name', {
                        get: function () {
                            return st[`name_${that.$i18n.locale}`]
                        }
                    })
                }
            }
            if (statusList.length) {
                that.selectedStatus = statusList[0]
            }
            return statusList;
        } catch (e) {
            console.error("Error fetching status list:", e);
            return [];
        }
    }
    private getLocalStatus(value:any) {
        const status = value.status;
        const curStatus = this.statusList.filter((item) => item.code === status);
        if (!curStatus || !curStatus.length) return status;
        const localName = curStatus[0]["name_" + this.$i18n.locale];
        return localName;
    }

    private showChildForms:boolean = false;
    private dataList:any[] = []
    private get filteredDataList() {
        let dataList = this.dataList
        if (this.isZeroReg) {
            if (dataList.length && this.showChildForms) {
                if (this.isReg) {
                    dataList = dataList[0].child_list
                } else {
                    if (this.form) {
                        dataList = dataList.concat(dataList[0].child_list.filter((v:any) => v.form_id === this.form?.id))
                    } else {
                        const tempList:any[] = []
                        for (const item of dataList) {
                            tempList.push(item)
                            for (const ch of item.child_list) {
                                tempList.push(ch)
                            }
                        }
                        dataList = tempList
                    }
                }
            }
        }
        dataList.sort((a:any, b:any) => {
            // Compare string fields
            if (a.region < b.region) return -1;
            if (a.region > b.region) return 1;

            // If string fields are equal, compare numerical fields
            if (a.abp === null && b.abp === null) return 0;      // Both null, considered equal
            if (a.abp === null) return -1;                      // 'a' has null abp, comes first
            if (b.abp === null) return 1;                       // 'b' has null abp, 'a' comes first

            //    b. If both 'abp' are not null, sort numerically
            return a.abp - b.abp;
        })
        if (this.selectedStatus && this.selectedStatus.hasOwnProperty('code') && this.selectedStatus.code) {
            dataList = dataList.filter(v => v.status.status === this.selectedStatus.code)
        }
        return dataList.map((item: any) => {
            if (this.form?.code === 'app26' && item.child_list && item.child_list.length > 0) {
                const aggStatus = this.computeAggregatedStatus(item.child_list)
                if (aggStatus !== null) {
                    return { ...item, status: { ...item.status, status: aggStatus } }
                }
            }
            return item
        })
    }

    private async getData(req:any = {}) {
        const that = this
        let dataList:any[] = []
        await axios.post('/api-py/input-forms', req).then(resp => {
            if (resp.status == 200) {
                dataList = resp.data
                that.loading = false
            }
        }).catch(e => {
            that.loading = false
        })
        return dataList
    }
    private loading = false
    private is_exist = false
    private async checkFormExist() {
        if (
            (
                (
                    (this.form && this.form.hasOwnProperty('code') && this.form.code && this.parentCodes.includes(this.form.code))
                    || this.currAbp === null
                    || (this.currAbp?.abp === null)
                    || (this.region?.code.endsWith('00'))
                )
                && this.form?.code !== 'app19'
                && this.form?.code !== 'app23'
                && this.form?.code !== 'app41'
            )
            || (this.showPrgFilter && (this.currPrg === null || !this.currPrg?.prg))
        ) {
            this.is_exist = true
            return
        }
        const req:any = {
            user_id: this.user_id,
            userBudgetLevel: this.userBudgetLevel,
            region: this.region.code,
            year: this.currYear,
            month: this.selectedMonth.key,
            form: this.form && this.form.hasOwnProperty('code') && this.form.code ? this.form.code: null,
            abp: (this.repType === 2  && !this.isZeroReg && this.form && this.form.hasOwnProperty('code') && this.currAbp && this.currAbp.hasOwnProperty('abp') ? this.currAbp.abp : null),
            prg: this.showPrgFilter ? (this.currPrg?.prg ?? null) : null,
            type: this.repType,
            operations: this.operationCode,
            edit_access: this.haveEditAccess,
            is_check: true
        }

        this.is_exist = false
        await axios.post('/api-py/input-forms', req).then(resp => {
            if (resp.status == 200) {
                if (this.form?.code === 'app19') {
                    resp.data.forEach((it: any) => {
                        if (it.form_code === 'app19') {
                            this.is_exist = true
                        }
                    })
                }
                else if (req.is_check) {
                    this.is_exist = resp.data
                }
            }
        }).catch(e => {})
    }
    private appParentCodes:any = {}
    private parentCodes: string[] = []
    private appChildCodes:any = {}
    private childCodes: string[] = []
    // Приложение 10 — только Excel-выгрузка, формы в таблице не загружаются
    private get isApp10() {
        return this.form?.code === 'app10'
    }

    private onApply() {
        if (this.isApp10) {
            this.downloadApp10Report()
        } else {
            this.loadData(false)
        }
    }

    private downloadApp10Report() {
        this.dataList = []
        this.currForm = null
        const year = (this.currYear - 1).toString()
        const params = new URLSearchParams()
        params.set('year', year)
        params.set('region', this.region.code)
        params.set('locale', this.$i18n.locale)
        this.loading = true
        this.makeToast('info', this.$t('modules.common.attention'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_download'))
        Ax(
            {
                url: `/api-py/application/input-forms/10/export?${params}`,
                method: 'get',
                responseType: 'blob',
            },
            (data: any) => {
                const url = window.URL.createObjectURL(new Blob([data]))
                const link = document.createElement('a')
                link.href = url
                const fileName = String(
                    this.$t('modules.budget_execution_monitoring.reports.app10._filenames.app10')
                ).replace('$year', year)
                link.setAttribute('download', fileName + '.xlsx')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                window.URL.revokeObjectURL(url)
                this.loading = false
            },
            (error: any, reason: any) => {
                this.loading = false
                // 400 — узловой регион XX0000/XXYY00, по нему Приложение 10 не формируется
                const message = reason?.response?.status === 400
                    ? this.$t('modules.budget_execution_monitoring.reports.app10._errors.node_region')
                    : error.toString()
                this.makeToast('danger', this.$t('modules.common.warning'), message)
            }
        )
    }

    private async loadData(is_create = false) {
        if (!this.form?.code) {
            return
        }
        this.dataList = []
        this.currForm = null
        const req: any = {
            user_id: this.user_id,
            userBudgetLevel: this.userBudgetLevel,
            region: this.region.code,
            year: this.currYear,
            month: this.selectedMonth.key,
            form: this.form?.code ? (this.isZeroReg && this.isReg && ['app8', 'app8_ex'].includes(this.form.code)? this.appParentCodes[this.form.code]: this.form.code): null,
            abp: this.repType === 2 && this.showAbpFilter && this.currAbp?.abp ? this.currAbp.abp : null,
            prg: this.repType === 2 && this.showPrgFilter && this.currPrg?.prg ? this.currPrg.prg : null,
            type: this.repType,
            operations: this.operationCode,
            edit_access: this.haveEditAccess,
            is_create: is_create,
            order_number: this.selectedOrder
        }
        this.selectedFormList = []
        this.selectAll = false
        this.showChildForms = this.region.code.slice(2, 6) === '0000' || (this.region.code.slice(4, 6) === '00' && this.childCodes.includes(this.form?.code))
        this.loading = true
        this.app21AbpForms = []
        const data: any = await this.getData(req)
        // родительский свод на согласовании/согласован — бэк форму не создал;
        // без проверки is_create: родительские формы (XXYY00 и др.) создаются и по «Применить»
        if (!Array.isArray(data) && data?.status === 303) {
            this.makeToast('danger', this.$t('modules.common.attention'), this.parentErrorText(data.parent))
            this.dataList = []
        } else {
            this.dataList = data
        }
        // app21 с выбранной БП: сервер вернул только формы этой БП, а строка АБП агрегируется по всем его формам 
        // догружаем их без фильтра по БП и без создания формы
        if (this.form?.code === 'app21' && req.prg) {
            this.app21AbpForms = await this.getData({ ...req, prg: null, is_create: false })
        }
        await this.checkFormExist()
    }

    // все формы app21 выбранного АБП без фильтра по БП (только для агрегации строки АБП); пусто — БП не выбрана
    private app21AbpForms: any[] = []

    private async deleteForm(form: any) {
        if (form.status.status === 26 || form.status.status === 31) {
            this.makeToast(
                'warning',
                this.$t(`${trPath}.massage_tools.deletion`),
                this.$t(`${trPath}.massage_tools.form_deletable_when_in_progress`)
            )
            return
        }

        let repdate:string = this.repdateText
        if (['app8_ex', 'app9_ex'].includes(form.form_code)) {
            repdate = `${form.year}-${form.month + 1}-1`
        }
        let req:any = Object.assign({repdate: repdate}, form)
        let path = '/api-py/fulfillment-report/app-9/data/delete'
        if (['app12', 'app14_rb', 'app14_ob'].includes(form.form_code)) {
            req = Object.assign({}, form)
            path = '/api-py/application/input-forms/409/data/delete'
        }

        const confirmed = await this.$bvModal.msgBoxConfirm(
            this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.confirm_form_deletion').toString(),
            {
                title: this.$t('modules.budget_execution_monitoring.reports.app_9.confirmation').toString(),
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.yes').toString(),
                cancelTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.cancellation').toString(),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
        )

        if (!confirmed) {
            return
        }

        try {
            this.loading = true
            const response = await fetch('/api-py/input-forms/delete', {
                method: 'POST',
                body: JSON.stringify(req),
            })

            if (!response.ok) {
                const errorBody = await response.json()
                if (errorBody?.detail?.code === 'app19_child_data') {
                    this.makeToast(
                        'warning',
                        this.$t(`${trPath}.massage_tools.massage`),
                        this.$t(`${trPath}.massage_tools.child_forms_has_data`)
                    )
                }
            }

            if (['app8_ex', 'app8', 'app12', 'app14_rb', 'app14_ob'].includes(form.form_code)) {
                axios.post(path, req)
                    .then(resp => {})
                    .catch(e => {})
            }
            if (this.isZeroReg) {
                this.loadData()
            } else {
                this.dataList = this.dataList.filter(v => v.id !== form.id)
            }
        } catch (error) {
            console.error(error)
        } finally {
            this.loading = false
        }
    }

    private async openHistory(agrObj: any) {
        if (agrObj !== null) {
            // eslint-disable-next-line
            // @ts-ignore
            await this.$refs.refHistModal.showEvent(agrObj);
        }
    }
    private openInputForm = false;
    private showDescriptionModal = false;
    private description:any = {general: '', mb: '', rb: '', ob: ''}

    private get mode() {
        if (!this.region) return 'form_msu'
        const xx = this.region.code.slice(0, 2)
        const yy = this.region.code.slice(2, 4)
        const zz = this.region.code.slice(4, 6)
        const yyzz = this.region.code.slice(2, 6)
        if (yyzz === '0000' || zz === '00') {
            if (zz === '00' && zz !== '0000' && this.childCodes.includes(this.form?.code)) {
                return 'form_abp'
            }
            return 'form_uo'
        } else {
            if (zz !== '00' && zz !== '01') {
                return 'form_msu'
            } else {
                return 'form_abp'
            }
        }
    }
    private moduleCode = '005.003.008'

    private async toggleOpen(val:any) {
        const form = this.inputFormList.find(v => v.code === val.form_code)
        if (form) {
            this.form = form
        }
        this.currForm = val
        if (!this.currForm.parent) {
            this.currForm.parent = await this.getParent(val)
        }
        if (this.inputFormFacade) {
            this.facade = this.inputFormFacade.getFacade(this.currForm)
        }
        if (this.facade) {
            this.filterSettingsForm = this.facade.getFilterSettings()
        }

        if (this.filterSettingsForm !== null) {
            if (this.statusList.length && 'child_status' in this.filterSettingsForm) {
                this.filterSettingsForm.child_status = this.statusList[0]
            }
            this.filterSettingsForm.user_id = this.user_id
            this.filterSettingsForm.edit_access = this.haveEditAccess
            this.filterSettingsForm.delete_access = this.haveDeleteAccess
        }
        this.openInputForm = true;
        this.showViewModelselect = [...this.parentCodes, ...this.childCodes].includes(val.form_code) && this.repType === 2
    }
    private async closeWindow() {
        this.openInputForm = false
        this.showViewModelselect = false
        this.filterSettingsForm = null
        await this.loadData()
    }

    private openDescriptionModal(val:any) {
        this.currForm = val
        this.description = Object.assign({}, val.description)
        this.showDescriptionModal = true
    }
    private closeDescriptionModal() {
        this.showDescriptionModal = false
        this.currForm = null
    }
    private async saveDescription() {
        this.currForm.description = this.description
        await axios.post('/api-py/input-forms/description', this.currForm).then(resp => {
            if (resp.status === 200) {
                this.closeDescriptionModal()
                this.loadData()
            }
        })
    }

    private operationCode:any[] = []

    private async loadOperations() {
        this.operationCode = [];
        if (store.state.user.sub === null) { return; }
        let result = null;
        try {
            result = await fetch(encodeURI(`/api/um/module/link?user=${store.state.user.sub}&modulecode=${this.moduleCode}`))
                .then(response => response.json());
        } catch (error) {
            this.makeToast('danger', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.user_operations_error'), error.toString());
            return;
        }
        if (result.operations) { this.operationCode = result.operations; }
    }

    private agreementData:any[] = [];
    private agreementTree:any = {};
    private async getAllAgreemenSteps() {
        await axios.get('/api-py/get-all-agreement-status/' + encodeURI(JSON.stringify({ mode_code: this.mode }))).then(resp => {
            if (resp.status === 200) {
                this.agreementData = resp.data.filter((agreement:any) => agreement.stepBack.length > 0 || agreement.stepForward.length > 0)
                    .map((agreement:any) => {
                        return {
                            agrCode: agreement.code,
                            stepBack: agreement.stepBack.map((sb:any) => sb.step_code),
                            stepForward: agreement.stepForward.map((sf:any) => sf.step_code)
                        }
                    });
                const tree:any = {}
                for (const agr of this.agreementData) {
                    tree[agr.agrCode] = {
                        agrCode: agr.agrCode,
                        stepBack: agr.stepBack.length > 0? agr.stepBack[0]: null,
                        stepForward: agr.stepForward.length > 0? agr.stepForward[0]: null
                    }
                }
                this.agreementTree = tree
            }
        })
    }

    private validateSelectedData() {
        if (this.selectedFormList.length < 2) return [true, true, true]; // No conflict with fewer than 2 items

        const firstStatus = this.selectedFormList[0].status.status;
        const { agrCode, stepBack, stepForward } = this.agreementTree[firstStatus] || {};
        let goBack = true
        let goForward = true
        for (let i = 1; i < this.selectedFormList.length; i++) {
            // if (!goBack && !goForward) break
            const stepInfo = this.agreementTree[this.selectedFormList[i].status.status];

            if (goBack && (!stepInfo || stepInfo.stepBack !== stepBack)) {
                goBack = false; // Validation failed
            }
            if (goForward && (!stepInfo || stepInfo.stepForward !== stepForward)) {
                goForward = false; // Validation failed
            }
        }
        return [goBack || goForward, goBack, goForward]; // Validation passed
    }

    // Все дочерние формы выбранных записей должны быть в статусе 26.
    // Признак родителя — непустой child_list: бэк заполняет его по parent_id для узлов (*00), сводов на XX0101 и app13cons.
    // app26/app41 на XX0101 пропускаем: у app26 parent_code ссылается на себя и child_list там не отражает реальных дочерних (как в get_form на бэке)
    private validateByChild() {
        const is0101 = this.region?.code?.slice(2, 6) === '0101'
        for (const sel of this.selectedFormList) {
            if (is0101 && ['app26', 'app41'].includes(sel.form_code)) {
                continue
            }
            for (const ch of (sel.child_list || [])) {
                if (ch.status.status !== 26) {
                    return false
                }
            }
        }
        return true
    }

    private async getParent(val:any) {
        if (val.region.slice(2, 6) === '0000') {
            return null
        } else {
            let parentL:any[] = []
            const req:any = {
                user_id: this.user_id,
                userBudgetLevel: this.userBudgetLevel,
                region: val.region,
                year: val.year,
                month: val.month,
                form: val.form,
                abp: null,
                type: this.repType,
                operations: this.operationCode,
                form_id: val.id
            }
            parentL = await this.getData(req)
            return parentL.length? parentL[0]['parent'] :null
        }
    }
    // первый родитель выбранных форм в статусе 26/31; null — блокирующих родителей нет
    private async getLockedParent() {
        for (const val of this.selectedFormList) {
            const parent:any = val.parent ? val.parent : await this.getParent(val)
            if (isParentLocked(parent)) {
                return parent
            }
        }
        return null
    }

    private parentErrorText(parent: any): string {
        return parentErrorText(this, parent)
    }
    private agrBtnLst: any = { back: [], forward: [] };
    private agrEnabled = true;
    // кнопка действия
    private async agreementEvent(show = true) {
        // app21: согласуются только записи с одинаковым статусом (RQ.eAk.MONF03.13);
        // общая проверка ниже сравнивает лишь шаги, и смесь 73 + 27 (общий шаг вперёд в 31) её проходит
        if (this.form?.code === 'app21' && new Set(this.selectedFormList.map(f => f.status.status)).size > 1) {
            if (show) this.makeToast('warning', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.same_status'));
            return
        }
        const [isValidRequest, goBack, goForward] = this.validateSelectedData()
        if (!isValidRequest) {
            if (show) this.makeToast('warning', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.no_common_agreement_steps'));
            return
        }
        const params = { modeCode: this.mode, operationCode: this.operationCode, agrCode: this.selectedFormList[0].status.status };
        if (!show) { this.agrEnabled = false; }
        let result: any[] = [];
        try {
            const response = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
            result = await response.json();
        } catch (error) {
            if (show) this.makeToast('danger', 'Ошибка get-agreement-step-next-back', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement_steps_error'));
            return;
        }
        if (result.length === 0) {
            if (show) this.makeToast('warning', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.no_agreement_steps'));
            return;
        }
        this.agrBtnLst = { back: [], forward: [] };

        for (const el of result) {
            if (el.stepType === 1) {
                if (goBack) this.agrBtnLst.back.push(el);
            } else {
                if (goForward) this.agrBtnLst.forward.push(el);
            }
        }
        if (this.agrBtnLst.back.length || this.agrBtnLst.forward.length) {
            this.agrEnabled = true;
        }
        if (show) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.refAgrModal.showEvent();
        }
    }

    private flk0Agr() {
        for (const form of this.selectedFormList) {
            if (form.flk === null || form.flk) {
                return true
            }
        }
        return false
    }
    private async agrClick(data:any) {
        // app21: возврат на доработку (31 → 27, 26 → 27) только с комментарием (RQ.eAk.MONF03.14);
        // основная проверка — в окне согласования, здесь — страховка
        if (this.form?.code === 'app21' && data.stepType === 1 && !(data.commentTxt || '').trim()) {
            this.makeToast('danger', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.comment_required'))
            return
        }
        const lockedParent = await this.getLockedParent()
        if (lockedParent) {
            this.makeToast('danger', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.parentErrorText(lockedParent))
            return
        }
        if (data.status === 31) {
            if (!this.validateByChild()) {
                this.makeToast('danger', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.validate_child_error'))
                return
            }
        }
        if (this.flk0Agr() && data.status === 31) {
            if (this.selectedFormList.length === 1 && this.selectedFormList[0]?.form_code === 'app23') {
                this.makeToast('danger', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.$t('modules.budget_execution_monitoring.reports._app23.flk_error'))
            } else {
                this.makeToast('danger', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.flk0_error'))
            }
            return
        }
        await axios.post(
            '/api-py/input-forms/status',
            {
                form_id: this.selectedFormList.map(value => value.id),
                description: data.commentTxt,
                status: data.status,
                user_id: this.$store.getters.user.sub
            }
        ).then(res => {
            if (res.status === 200){
                this.loadData()
            } else if (res.status === 303) {
                this.makeToast('danger', this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.agreement'), this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.flk0_error'))
            }
        })
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
        const refItem: any = this.$refs[refName];
        setTimeout(() => refItem.$el.focus(), 100);
    }
    private get regionBreadCrumb() {
        if (this.currForm && this.currForm.hasOwnProperty('region')) {
            return this.currForm.region
        } else if (this.region && this.region.hasOwnProperty('code')) {
            return this.region.code
        } else return null
    }
    private get abpBreadCrumb() {
        if (this.repType === 2 && this.currForm && this.currForm.hasOwnProperty('abp') && this.currForm.abp) {
            return this.currForm.abp
        } else if (!this.isZeroReg && this.currAbp && this.currAbp.hasOwnProperty('abp') && this.currAbp.abp) {
            return this.currAbp.abp
        } else return null
    }

    private setNameLang(obj: any, codeName: string) {
        if (obj === null) { return null; }
        const that = this
        Object.defineProperty(obj, 'name', {
            get: function () {
                let txt = obj['name_' + that.$i18n.locale];
                if (txt === undefined) { txt = obj.name_ru; }
                if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
                    txt = obj[codeName] + ' - ' + txt;
                }
                return txt
            }
        })
    }
    private computeAggregatedStatus(childList: any[]): number | null {
        if (!childList || childList.length === 0) return null
        const priority = [73, 27, 31, 26]
        for (const code of priority) {
            if (childList.some((ch: any) => ch.status && ch.status.status === code)) {
                return code
            }
        }
        return childList[0].status ? childList[0].status.status : null
    }

    private isParentRow(data: any): boolean {
        return this.form?.code === 'app26' && (data.abp === null || data.abp === undefined)
    }

    private getHeaderStyle(fieldKey: string): string {
        if (this.form?.code !== 'app21') {
            return ''
        }
        if (fieldKey === 'action') {
            return 'width: 40px; min-width: 40px;'
        }
        if (fieldKey === 'expand') {
            return 'width: 40px; min-width: 40px; text-align: center;'
        }
        if (fieldKey === 'region') {
            return 'max-width: 150px;'
        }
        if (fieldKey === 'prg') {
            return 'max-width: 260px;'
        }
        if (fieldKey === 'form') {
            return 'max-width: 180px;'
        }
        if (fieldKey === 'order_number') {
            return 'width: 40px;'
        }
        if (fieldKey === 'rep_period' || fieldKey === 'update_date') {
            return 'width: 1%;'
        }
        return ''
    }

    // раскрытие/сворачивание родительских групп app21, ключ - abp группы, по умолчанию развёрнуто (RQ.25)
    private expandedRows: Record<string, boolean> = {}
    private toggleExpandRow(key: string) {
        this.$set(this.expandedRows, key, !this.isGroupExpanded(key))
    }
    private isGroupExpanded(key: string): boolean {
        return this.expandedRows[key] !== false
    }
    private get isAllGroupsExpanded(): boolean {
        return this.app21Groups.every((group) => this.isGroupExpanded(group.key))
    }
    private toggleExpandAllRows() {
        const expand = !this.isAllGroupsExpanded
        this.app21Groups.forEach((group) => {
            this.$set(this.expandedRows, group.key, expand)
        })
    }

    /**
     * Динамическая группировка app21 по abp.
     * Дочерние строки — отфильтрованный filteredDataList (фильтры БП и статуса).
     * Родительская строка считается по ВСЕМ формам АБП, без учёта фильтров БП и статуса:
     * статус - агрегированный (computeAggregatedStatus),
     * дата/пользователь - от формы с максимальной status.create_date.
     */
    private get app21Groups(): { key: string; number: number; parent: any; children: any[] }[] {
        if (!this.form || this.form.code !== 'app21') {
            return []
        }
        const groupByAbp = (list: any[]) => {
            const keys: string[] = []
            const map: Record<string, any[]> = {}
            for (const item of list) {
                const key = `${item.abp}`
                if (!map[key]) {
                    map[key] = []
                    keys.push(key)
                }
                map[key].push(item)
            }
            return { keys, map }
        }
        const { keys: groupKeys, map: groupsMap } = groupByAbp(this.filteredDataList)
        // все формы: при выбранной БП — догруженные без фильтра по БП (при ошибке пусто — тогда видимые),
        // иначе dataList (до фильтра статуса)
        const allForms = groupByAbp(this.app21AbpForms.length ? this.app21AbpForms : this.dataList).map
        // код БП как число; форма без БП — в конце группы
        const prgOrder = (item: any): number => {
            const prg = Number(item.prg)
            return item.prg === null || item.prg === undefined || Number.isNaN(prg) ? Infinity : prg
        }
        return groupKeys.map((key: string, index: number) => {
            // строки БП внутри строки АБП — по коду БП по возрастанию (1, 2, 4, 7, 106, 168); копия, исходные списки не меняются
            const children = [...groupsMap[key]].sort((a: any, b: any) => prgOrder(a) - prgOrder(b))
            const abpForms = allForms[key] || children
            let latestChild = abpForms[0]
            for (const child of abpForms) {
                if (child.status && latestChild.status && child.status.create_date > latestChild.status.create_date) {
                    latestChild = child
                }
            }
            return {
                key,
                number: index + 1,
                parent: {
                    abp: children[0].abp,
                    region: children[0].region,
                    order_number: children[0].order_number,
                    status: {
                        status: this.computeAggregatedStatus(abpForms),
                        create_date: latestChild.status ? latestChild.status.create_date : null,
                        user_id: latestChild.status ? latestChild.status.user_id : null
                    }
                },
                children
            }
        })
    }

    private async loadPrgCacheForAbp(abp: string) {
        const cacheKey = `${this.currYear}-${abp}`
        if (this.prgCacheByAbp[cacheKey] || this.prgCacheLoading[cacheKey]) {
            return
        }
        this.$set(this.prgCacheLoading, cacheKey, true)
        const url = this.form?.code === 'app26'
            ? '/api-py/input-forms/reserve-programs'
            : '/api-py/input-forms/budget-programs'
        try {
            const resp = await axios.post(url, { year: this.currYear, abp })
            if (resp.status === 200) {
                this.$set(this.prgCacheByAbp, cacheKey, resp.data)
            }
        } finally {
            this.$set(this.prgCacheLoading, cacheKey, false)
        }
    }

    // прогр. коды детей app21-группы могут принадлежать разным АБП, отличным от currAbp фильтра,
    // поэтому имя программы подгружается и кешируется отдельно по каждой встреченной АБП (RQ.25)
    private getPrgLabel(child: any): string {
        const abp = `${child.abp}`
        const cacheKey = `${this.currYear}-${abp}`
        const list = this.prgCacheByAbp[cacheKey]
        if (!list) {
            this.loadPrgCacheForAbp(abp)
            return `${child.prg}`
        }
        const found = list.find((p: any) => p.prg === child.prg)
        const prg = String(found?.prg ?? child.prg).padStart(3, '0');
        return found
            ? `${prg} - ${found[`name_${this.$i18n.locale}`]}`
            : prg; 
        }

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

}
